module.exports = __webpack_public_path__ + "static/img/5.d7d0cec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/5.png
// module id = vuvL
// module chunks = 0